import { __require as t } from "../us_street/Candidate.mjs";
var e, i;
function r() {
  if (i) return e;
  i = 1;
  const r = t();
  return e = class {
    constructor(t) {
      this.text = t.text, this.verified = t.verified, this.line = t.line, this.start = t.start, this.end = t.end, this.candidates = t.api_output.map(t => new r(t));
    }
  };
}
export { r as __require };